export default __webpack_public_path__ + "static/media/NIAS0360.34I-32925_-17934_0.35880e6c.jpg";